import React, { useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import MenuHourEdit from './MenuHourEdit';
// import { mergeMenuHours } from '../../Order/StartStopModal/helpers';

const Container = styled.div`
  padding-left: 20%;
`;

const Flex = styled.div`
  justify-content: space-between;
  padding: 0.5rem 0rem;
  padding-right: 50%;
`;

const HoursButton = styled.button`
  &&& {
    border-color: ${({ theme }) => theme.primaryColor};
    border-width: 2px;
    color: ${({ theme }) => theme.primaryColor};
    font-weight: 600;
    width: 60%;
    margin-bottom: 1rem;
  }
`;

const sorter = {
  MON: 1,
  TUE: 2,
  WED: 3,
  THU: 4,
  FRI: 5,
  SAT: 6,
  SUN: 7,
};

const sort = hours => {
  hours.sort((a, b) => {
    const day1 = a.day;
    const day2 = b.day;
    return sorter[day1] - sorter[day2];
  });
  return hours;
};

const mergeMenuHours = (menuHours, customHours) => {
  const mergedHours = menuHours;
  customHours.forEach(ch => {
    const day = moment(ch.date)
      .format('ddd')
      .toUpperCase();
    const temp = mergedHours.find(mh => mh.day === day);
    temp.option = ch.option;
    temp.isCustom = true;
  });
  return mergedHours;
};

const WeeklyHours = ({ place, userId, fetchMenus, menu, customHours }) => {
  const menuHoursArry = customHours.filter(
    item => item.menu_id === menu.menu_id,
  );
  const finalMenuHours =
    menuHoursArry.length !== 0
      ? mergeMenuHours(menu.menu_hour, menuHoursArry)
      : menu.menu_hour;
  const hours = sort(finalMenuHours);
  const [isActiveHourModal, setIsActiveHourModal] = useState(false);
  return (
    <Container>
      {isActiveHourModal && (
        <MenuHourEdit
          place={place}
          userId={userId}
          menu={menu}
          isActiveHourModal={isActiveHourModal}
          onClose={() => setIsActiveHourModal(false)}
          fetchMenus={fetchMenus}
        />
      )}
      <h3 className="has-text-weight-semibold is-size-1">
        Menu Hours for: {menu.service_type} - {menu.name}
      </h3>
      <br />
      <HoursButton
        type="button"
        className="button control"
        isActive={isActiveHourModal}
        onClick={() => setIsActiveHourModal(true)}
      >
        Add / Edit menu hours
      </HoursButton>
      {hours.map(item => (
        <Flex className="is-flex">
          <p
            className="is-size-4 has-text-weight-semibold"
            style={{ width: '60px' }}
          >
            {item.day} {item?.isCustom && '(ch)'}
          </p>
          <div className="is-size-6 has-text-weight-semibold">
            {item.option
              ? item.option.map(option => {
                  if (
                    option.start_in_sec === 0 &&
                    option.end_in_sec === 86340
                  ) {
                    return <p>Open 24 Hours</p>;
                  }
                  return (
                    <p className="is-uppercase">
                      {option.start.length !== 0
                        ? `${option.start} - ${option.end}`
                        : ''}
                    </p>
                  );
                })
              : 'Closed'}
            {item.option.length === 0 && 'Closed'}
          </div>
        </Flex>
      ))}
    </Container>
  );
};

export default WeeklyHours;
